<template>
  <div class="visitor-counter">
    <span class="counter-label">访问</span>
    <div class="counter-digits">
      <div
        v-for="(digit, index) in displayDigits"
        :key="index"
        class="digit-slot"
      >
        <div class="digit-column" :style="getColumnStyle(digit, index)">
          <div v-for="n in 10" :key="n" class="digit-num">{{ n - 1 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  count: {
    type: Number,
    default: 0
  },
  animate: {
    type: Boolean,
    default: true
  }
})

// 6位数字显示
const displayDigits = computed(() => {
  const count = Math.min(props.count, 999999)
  const str = count.toString().padStart(6, '0')
  return str.split('').map(Number)
})

const prevDigits = ref([0, 0, 0, 0, 0, 0])
const isAnimating = ref(false)

// 计算列的transform位置
function getColumnStyle(digit, index) {
  const digitHeight = 28
  const translateY = -digit * digitHeight
  const shouldAnimate = props.animate && isAnimating.value && digit !== prevDigits.value[index]

  return {
    transform: `translateY(${translateY}px)`,
    transition: shouldAnimate ? 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)' : 'none'
  }
}

// 监听数字变化
watch(() => props.count, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    isAnimating.value = true
    setTimeout(() => {
      prevDigits.value = [...displayDigits.value]
      isAnimating.value = false
    }, 600)
  }
}, { immediate: true })
</script>

<style scoped>
.visitor-counter {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 14px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.counter-label {
  font-size: 12px;
  font-weight: 500;
  color: #86868b;
  letter-spacing: 0.3px;
}

.counter-digits {
  display: flex;
  gap: 2px;
}

.digit-slot {
  width: 18px;
  height: 28px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.digit-column {
  display: flex;
  flex-direction: column;
}

.digit-num {
  width: 18px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  flex-shrink: 0;
}

/* 响应式 */
@media (max-width: 768px) {
  .visitor-counter {
    padding: 4px 10px;
    gap: 6px;
  }

  .counter-label {
    font-size: 11px;
  }

  .digit-slot {
    width: 16px;
    height: 24px;
  }

  .digit-num {
    width: 16px;
    height: 24px;
    font-size: 13px;
  }
}
</style>
